const nav = {
  items: [
    {
      title: true,
      name: "Reporting",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "fas fa-tachometer-alt",
    },
    {
      divider: true,
      role: "Admin",
    },
    {
      title: true,
      name: "Admin",
      role: "Admin",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Summary Dashboard",
      url: "/performance-overview",
      icon: "fas fa-tachometer-alt",
      role: "Admin",
    },
    {
      name: "Content Manager",
      url: "/content-manager",
      icon: "far fa-newspaper",
      role: "Admin"
    },
    {
      name: "Publisher Manager",
      url: "/publisher-manager",
      icon: "far fa-building",
      role: "Admin"
    },
    {
      name: "Users",
      url: "/users",
      icon: "far fa-user",
      role: "Admin",
    },
  ],
};

export default nav;
